<template>
  <li
    class="oct-card-list__item"
    :class="`oct-card-list__item--col-${columnWidth}`"
  >
    <slot />
  </li>
</template>

<script>
export default {
  name: 'OctCardListItem',
  props: {
    /** Title Text */
    title: {
      type: String,
      default: ''
    },
    /** Text under the title */
    text: {
      type: String,
      default: ''
    },
    /** Number of columns */
    cols: {
      type: Number,
      default: 4
    },
  },
  computed: {
    columnWidth () {
      return 12/this.cols
    }
  }
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-card-list__item {
  margin: 0 0 oct-rem(48);
  padding: 0 oct-rem(6);
  flex: 0 0 100%;
  max-width: 100%;

  &--col-3 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  &--col-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .oct-card-list--slider & {
    flex: 1 1 auto;
  }

  .oct-card-list--dynamic & {
    flex: 0 0 50%;
    max-width: 50%;

    &:nth-child(5n+1) {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  margin-bottom: oct-rem(80);
  flex: 0 0 (100%/4);
  max-width: (100%/4);
  padding: 0 oct-rem(12);

  .oct-card-list--dense & {
    margin-bottom: oct-rem(28);
  }

  &--col-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  &--col-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .oct-card-list--dynamic & {
    flex: 0 0 25%;
    max-width: 25%;

    &:nth-child(5n+1) {
      flex: 0 0 50%;
      max-width: 50%;
    }
  }
}
}
</style>
